import React from 'react';
import clsx from 'clsx';
import {
  Dropdown,
} from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { fieldTypeName } from '@/constants/fields';

const listItem = (field, value, errors, intl, byName) => {
  const className = errors.includes(field.constraints) ? 'error' : '';
  const identifier = byName ? field.name : field.uuid;
  return {
    key: `dictionary_field_dropdown_item_${identifier}`,
    text: field.label,
    value: identifier,
    active: identifier === value,
    description: intl.formatMessage({ id: fieldTypeName(field.type) }),
    disabled: field.disabled,
    className,
  };
};

const listItems = (fields, value, errors, intl, byName) => fields.map(
  (field) => listItem(field, value, errors, intl, byName),
);

const DictionaryFieldDropdown = ({
  fields,
  fieldIdentifier,
  errors = [],
  disabled,
  onChange,
  className,
  inline,
  byName,
  message,
  searchable,
}) => {
  const intl = useIntl();
  const placeholder = message ? intl.formatMessage({ id: message }) : null;
  return (
    <Dropdown
      className={clsx('aridhia-dictionary-field-dropdown max-content', className)}
      options={listItems(fields, fieldIdentifier, errors, intl, byName)}
      placeholder={placeholder}
      disabled={disabled}
      value={fieldIdentifier}
      fluid
      selection={!inline}
      scrolling={inline}
      onChange={(e, { value }) => onChange(value)}
      inline={inline}
      search={searchable}
    />
  );
};

export default DictionaryFieldDropdown;
